// Features/Product-Link/mod.ts
import { fetchCart, openCart, addItems } from "Cart";

// Features/Product-Link/Variant.ts
async function fetchVariant({ variantId, handle }) {
  console.debug("Fetch VAriant", variantId, handle);
  return await fetch(`/products/${handle}.js`).then((response) => response.json()).then((data) => data).then((product) => {
    console.debug("Product", { product, variantId });
    const { variants, ...rest } = product;
    const variant = variants.find((variant2) => variant2.id === variantId);
    if (variant)
      return { ...rest, variant };
    console.error(`Couldn't find fitting variant in product data!`, { variantId, handle });
    return null;
  });
}

// Features/Product-Link/Helper.ts
var Valid_Addition = /^(\w+)(-\w+)*(:\d{10,16})(:\d{1,3})?$/;
function isValid(addition) {
  if (Valid_Addition.test(addition))
    return true;
  console.error(`Product link contains invalid addition instruction`, addition);
  return false;
}
function normalize(addition) {
  const [handle, variantId, quantity] = addition.split(":");
  return {
    variantId: parseInt(variantId),
    quantity: parseInt(quantity ?? "1"),
    handle
  };
}

// Features/Product-Link/mod.ts
var parameters = window.ProductLink;
if (parameters) {
  const additions = parameters.filter(isValid).map(normalize);
  let variants = new Array;
  for (const addition of additions) {
    const { quantity, ...rest } = addition;
    const variant = await fetchVariant(rest);
    if (!variant)
      continue;
    variants.push({ quantity, variant });
  }
  const anySamples = !!variants.find((variant) => variant.variant.type.includes(`Muster`));
  console.debug("Variants", { variants, anySamples });
  if (anySamples) {
    const cart = await fetchCart();
    if (cart)
      variants = variants.filter((variant) => {
        if (!variant.variant.type.includes(`Muster`))
          return true;
        const inCart = !!cart.items.find((item) => item.variant_id === variant.variant.variant.id);
        variant.quantity = 1;
        return !inCart;
      });
  }
  const items = variants.map((variant) => {
    return {
      quantity: variant.quantity,
      id: variant.variant.variant.id
    };
  });
  console.debug("Items", items);
  if (items.length)
    addItems({ items }).then(() => {
      console.log(`Added items from product link`, { items });
      openCart();
    }).catch((exception) => {
      console.error(`Failed to add items from product link`, { items }, exception);
    });
}
